module.exports = __webpack_public_path__ + "static/img/200140.d17fade2.png";